import { useState, useEffect, useContext } from "react";
import CountryConverter from "./CountryConverter";
import { FaArrowsRotate } from "react-icons/fa6";
import { AppContext } from "../AppProviderDesktop";


function ConverterContiner({fromName, fromSymbol, toName, toSymbol}) {
    const [data, setData] = useState({fromName: fromName, fromSymbol: fromSymbol, toName: toName, toSymbol: toSymbol, sum: 0});
    const [result, setResult] = useState(0);

    const {gates} = useContext(AppContext);

    useEffect(() => {
        if (data.sum && data.sum > 0 && data.fromName && data.toName) {
            const subFromName = data.fromName.substring(0, 3).toUpperCase();
            const subToName = data.toName.substring(0, 3).toUpperCase();

            if (subFromName in gates && subToName in gates) {
                let sum = data.sum;

                if (subFromName !== 'USD') {
                    sum /= gates[subFromName];
                }

                if (subToName !== 'USD') {
                    sum *= gates[subToName];
                }
                
                setResult(sum.toFixed(2));

            } else {
                setResult(0);
            }
        }

    }, [data])

    const changeRotate = () => {
        setData({sum: data.sum, fromName: data.toName, fromSymbol: data.toSymbol, toName: data.fromName, toSymbol: data.fromSymbol});
    }

    return (<>
        <div className={'converter-input-sum'}>
            <input placeholder={"0"} value={data.sum || ""} onChange={(event) => setData({...data, sum: event.target.value})} />
            <p> {data.fromSymbol} </p>
        </div>

        <CountryConverter 
        value={data.fromName}
        setValue={(v, s) => setData({...data, fromName: v, fromSymbol: s})}
        />

        <FaArrowsRotate 
        onClick={changeRotate} 
        style={{'cursor': 'pointer'}}
        />

        <CountryConverter 
        value={data.toName}
        setValue={(v, s) => setData({...data, toName: v, toSymbol: s})}
        />

        <div className="result-converter">
            <p> {result} </p>
            <p> {data.toSymbol} </p>
        </div>
    </>)
}


export default ConverterContiner;